import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import "../../assets/css/admin/loginPage.css";
import { auth } from "../../firebase/firebase";

function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState(false);

    const [message, setMessage] = useState("");

    const login = async (e) => {

        e.preventDefault();

        if (!email || !password) {
            setMessage("Please enter email and password.");
            return;
        }

        setLoading(true);
        setMessage("");

        try {

            await signInWithEmailAndPassword(
                auth,
                email,
                password
            );

            localStorage.setItem("isAdminLoggedIn", "true");

            navigate("/admin/layout");

        } catch (error) {

            switch (error.code) {

                case "auth/user-not-found":
                    setMessage("No account found with this email.");
                    break;

                case "auth/wrong-password":
                    setMessage("Incorrect password.");
                    break;

                case "auth/invalid-email":
                    setMessage("Invalid email address.");
                    break;

                case "auth/invalid-credential":
                    setMessage("Invalid email or password.");
                    break;

                default:
                    setMessage(error.message);

            }

        }

        setLoading(false);

    };

    return (

        <div className="login-page">

            <form className="login-box" onSubmit={login}>

                <h2>Admin Login</h2>

                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <div className="password-box">

                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <span
                        className="eye-icon"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>

                </div>

                {message && (
                    <p className="login-message">
                        {message}
                    </p>
                )}

                <button
                    type="submit"
                    disabled={loading}
                >
                    {loading ? "Please Wait..." : "Login"}
                </button>

                <div style={{ marginTop: "15px", textAlign: "center" }}>

                    <p>
                        <Link to="/admin/forgot-password">
                            Forgot Password?
                        </Link>
                    </p>

                  { /* <p>
                        Don't have an account?{" "}
                        <Link to="/admin/register">
                            Register
                        </Link>
                    </p>  */}

                </div>

            </form>

        </div>

    );

}

export default Login;